import {CanActivateFn} from '@angular/router';
import {inject} from "@angular/core";
import {SdkService} from "../services/sdk.service";

export const SdkGuard: CanActivateFn = async (route, state) => {
  const sdkService = inject(SdkService);
  return sdkService.isInitialized();
};
